module.exports = __webpack_public_path__ + "img/youji.9029e060.png";